export default __webpack_public_path__ + "static/media/lb.55d98797.jpg";